/**
 * Class representing an option for break durations.
 */
export default class BreakMinuteListOption {
  /**
   * Create a BreakMinuteListOption.
   * @param {number} id - The number of break minutes being selected.
   * @param {string} text - The text that will be displayed in the select drop down input.
   */
  constructor(id, text) {
    /**
     * @property {number} id - Identifies the option and represents the number of break minutes.
     */
    this.id = id

    /**
     * @property {string} text - The text that will be displayed in the select drop down input.
     */
    this.text = text
  }
}
